import type { CalculatorReport } from '#/modules/salaries/types/CalculatorReport';
import type { FiltersUsed } from '#/modules/salaries/types/FiltersUsed';

const DEFAULT_HISTOGRAM_DATA = {
  median: 70000,
  x: [31111, 42222, 53333, 64444, 75556, 86667, 97778, 108889, 120000],
  y: [95, 114, 133, 152, 171, 152, 133, 114, 95],
  xEdges: [
    20000, 30000, 40000, 50000, 60000, 70000, 80000, 90000, 100000, 110000,
    120000, 130000,
  ],
};

const DEFAULT_FILTERS_USED: FiltersUsed = {
  cityBucket: 'HIGH',
  yearsOfExperience: [0, 100],
};

export const DEFAULT_SCATTER_DATA = {
  x: [
    20628.190498123284, 21722.073905292837, 22814.187074172263,
    23904.55571965299, 24993.291194292382, 26080.244084348207,
    27165.471638875388, 28248.954670003866, 29330.71142193796,
    30410.767688207896, 31489.114032156285, 32565.705786938073,
    33640.62662424891, 34713.79601794561, 35785.25423109978, 36855.032719236086,
    37923.02327534963, 38989.31145846755, 40053.893493926866, 41116.75302485476,
    42177.858595726546, 43237.20014077434, 44294.79779153392, 45350.64903156332,
    46404.73121288477, 47457.03426973037, 48507.40469913969, 49555.97335609539,
    50602.936523071476, 51648.364660443214, 52692.47669866239,
    53735.31290080058, 54777.24821671196, 55818.567004339624, 56859.72222323897,
    57901.17689873325, 58943.633118133315, 59987.971636130176,
    61035.38021333571, 62087.28063946543, 63145.56024600005, 64212.63733367691,
    65291.62725766023, 66386.4908976176, 67502.05982213971, 68643.9859599009,
    69818.1779166569, 71029.45719523051, 72279.2279702434, 73563.04117228495,
    74870.43846850988, 76188.42998544672, 77506.06920050716, 78814.06037703805,
    80100.54604045633, 81352.83829032749, 82561.72694902548, 83724.25771367247,
    84843.34462407467, 85925.56062666909, 86978.50537621815, 88009.32556792893,
    89024.22674771013, 90028.11597741168, 91024.86857767406, 92017.43885137509,
    93008.14192513119, 93998.74434120831, 94990.34830119119, 95984.03587512884,
    96980.4663708185, 97980.04745186001, 98983.38809721117, 99990.58393166697,
    101001.82117193357, 102017.22564010964, 103036.85773080257,
    104060.64195075312, 105088.39208325525, 106120.2842792471,
    107156.49468966688, 108196.78173608507, 109241.12528696588,
    110289.65619729197, 111342.20334900908, 112398.70634750983,
    113459.2960477769, 114523.8113975239, 115592.19200214345,
    116664.55865085036, 117740.75029135821, 118820.71659482758,
    119904.56828470531, 120992.16444024083, 122083.43460105885,
    123178.49955637415, 124277.2083196683, 125379.49043056596,
    126485.48680981775, 127595.02633936937, 128708.04862461347,
  ],
  y: [
    2.5487982708474837, 5.914532460496591, 9.292116452220297,
    12.681527281285929, 16.08172005235551, 19.493865966796875, 22.9174253533915,
    26.35245562397117, 29.798784543040608, 33.2561939456391, 36.72476420833116,
    40.2045297782158, 43.695169149035195, 47.19693493284908, 50.7095974823304,
    54.23291566778584, 57.767498054631986, 61.31275904218487, 64.86872159517728,
    68.43538571360915, 72.01291215060947, 75.60130090617814, 79.20035678008726,
    82.8101084782527, 86.43052729475858, 90.06178546510013, 93.70463508427342,
    97.35832405728242, 101.02156061791257, 104.69389695387619,
    108.37404704014192, 112.06166640571927, 115.75460784810045,
    119.45118345943183, 123.14875803663578, 126.8445959059291,
    130.53442562702907, 134.2132265352485, 137.87382789280102,
    141.50748587771002, 145.10231337021025, 148.6425623048508,
    152.10674343300505, 155.46555662633583, 158.67910066177214,
    161.69331942912328, 164.43648545638376, 166.81910302726718,
    168.74187837875007, 170.11891013403798, 170.9086079063224,
    171.13227004988934, 170.8586610479897, 170.08638238428426,
    168.76201629638672, 166.87478891583189, 164.46845164665808,
    161.62477400789294, 158.43790494478665, 154.99544845376923,
    151.36853061790848, 147.61141135939783, 143.7649994789557,
    139.85881901106308, 135.91472951066135, 131.9487775847266,
    127.97307425916792, 123.99685709771502, 120.02583570703614,
    116.06572256439107, 112.11991645021979, 108.19078847317394,
    104.28163981357946, 100.39319386051649, 96.5266505212688, 92.68291116159496,
    88.86253841744616, 85.06538301805986, 81.29055508004382, 77.53939229907799,
    73.81301420588157, 70.1104333169484, 66.43166685582803, 62.77782861205645,
    59.148045925791045, 55.542318797031776, 51.96163470928485,
    48.405293238202866, 44.87317956012228, 41.36625819381663,
    37.883886126770214, 34.42590260585416, 30.993318079307326,
    27.585443605148672, 24.202141394981968, 20.844479308877894,
    17.511642098825504, 14.203549388260344, 10.921314966718493,
    7.664054691990876, 4.4316652227803734,
  ],
};

export const DEFAULT_CHART_DATA: CalculatorReport = {
  submissionData: {
    histogramData: DEFAULT_HISTOGRAM_DATA,
    filtersUsed: DEFAULT_FILTERS_USED,
  },
  estimatedRange: {
    jobTitleId: '',
    jobTitleName: '',
    salary: 0,
    sectionLimits: {
      middle68UpperBound: 0,
      middle68LowerBound: 0,
      middle95UpperBound: 0,
      middle95LowerBound: 0,
    },
    scatterData: DEFAULT_SCATTER_DATA,
    synonymId: '',
    synonymName: '',
  },
};
